import { render, staticRenderFns } from "./VerifyIdentityConfirmation.vue?vue&type=template&id=376dfc0a&scoped=true"
import script from "./VerifyIdentityConfirmation.vue?vue&type=script&lang=js"
export * from "./VerifyIdentityConfirmation.vue?vue&type=script&lang=js"
import style0 from "./VerifyIdentityConfirmation.vue?vue&type=style&index=0&id=376dfc0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376dfc0a",
  null
  
)

export default component.exports